import request from 'src/lib/data/request'

// EMOJI =============================================

export const emoji = boardId =>
  request().get('/api/util/emoji').set('accept', 'json').query({ boardId })
